import { ScoreRange, ScoreDescription } from "../../types";
import ScoreRanges from "./ScoreRanges";
import ScoreDescriptions from "./ScoreDescriptions";
import { useState, useEffect, useCallback } from "react";

interface ScoreReferenceGuideProps {
  scoreRanges: [ScoreRange];
  scoreDescriptions: [ScoreDescription];
}

const ScoreReferenceGuide: React.FC<ScoreReferenceGuideProps> = ({
  scoreRanges,
  scoreDescriptions,
}) => {
  const [isTransformed, setIsTransformed] = useState(false);
  const [transformValue, setTransformValue] = useState(160);

  const updateTransformValue = useCallback(() => {
    if (window.innerWidth < 767) {
      setTransformValue(205);
    } else {
      setTransformValue(160);
    }
  }, []);

  useEffect(() => {
    updateTransformValue();

    window.addEventListener("resize", updateTransformValue);
    return () => {
      window.removeEventListener("resize", updateTransformValue);
    };
  }, [updateTransformValue]);

  return (
    <div
      data-w-id="bfb042bd-904a-82c5-577f-101b32246486"
      className="score-cheatsheet"
      style={{
        transform: isTransformed
          ? `translate3d(0px, ${transformValue}px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
          : "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
        transformStyle: "preserve-3d",
        transition: "transform 0.5s ease",
      }}
    >
      <ScoreRanges scoreRanges={scoreRanges} />

      <ScoreDescriptions scoreDescriptions={scoreDescriptions} />
      <div
        className="downarrow-div cursor-pointer"
        onClick={() => setIsTransformed(!isTransformed)}
      >
        <p className="paragraph-5">Quick reference guide</p>
        <img
          src="images/down-arrow-icon.png"
          loading="lazy"
          alt=""
          className="image-5"
          style={
            isTransformed
              ? {
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(180deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }
              : {}
          }
        />
      </div>
    </div>
  );
};

export default ScoreReferenceGuide;
